import React, { useEffect, useState, useContext, useCallback } from 'react';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { AnchorWithLink } from 'atoms/Anchor';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import SearchStoreCard from './SearchStoreCard';
import SearchStoreClosedCard from './SearchStoreClosedCard';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { UserOrderContext } from 'context/context';
import clearTextIcon from 'styles/staticAssets/images/clearTextIcon.jpg';
import MyMapComponent from './MapComponent';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import {
  isMobileDevice,
  getValueOrDefaultObject,
  getValueOrEmptyString,
  getValueOrDefaultArray,
  getAndCheck,
  addressSuggestionLengthMatch,
  getLength,
  getValueOrDefaultAlternativeObject,
  getTernaryValue,
  manipulateAlreadySearchedLocations,
  getEmbeddedErrorMessageAnalytic,
} from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import {
  getChannels,
  compareDname,
  callUtilFunct,
  localisationViewAnalyticsData,
  setUseMyLocationAnalytics,
} from '../SearchStoreUtilities/SearchStoreUtils';
import NegativeScenarioErros from './NegativeScenarioErros';
import { useDispatch, useSelector } from 'react-redux';
import { setStoresFavourite, setStoresUnFavourite } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { ChannelManager } from 'common/manager';
import { Config } from 'common/constants/SharedConstants';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import SEARCHSTORE_MODULE_DATA from 'organisms/SearchStore/Data/Defaults';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const {
  Error: ErrorImage,
  LocationImage,
  MapImage,
  Union,
  GoogleMapLocationImage,
  SuggestionItemSearchPin,
  Time_Clock,
  SuccessImg,
} = IMAGE_PATH;

const getTabStyle = firstTab => {
  if (firstTab === true) {
    return 'store-count-title fav-store savedKFC';
  } else {
    return 'store-count-title active-tab fav-store savedKFC';
  }
};

const getEligibleStoreHeader = (loggedIn, firstTab) => {
  if (loggedIn && firstTab) {
    return 'store-count-title active-tab savedKFC';
  } else if (loggedIn && !firstTab) {
    return 'store-count-title savedKFC';
  } else if (!loggedIn) {
    return 'store-count-title  guest-color';
  }
};

const getStoresWithCatalog = storeInfo => {
  return storeInfo?.summary?.menu?.catalogs?.length > 0;
};

const getSourceFile = showMap => {
  if (showMap) {
    return Union;
  } else {
    return MapImage;
  }
};

export const keyDownUpArrows = e => {
  let focusModal = document.querySelector('.searchStore-module-form .store-count a.store-location-link');
  if (e.key === 'ArrowDown' && typeof focusModal != undefined && focusModal != null) {
    focusModal.focus();
  }
};

export const eligibleStoreFun = (
  firstTab,
  eligibleStoreDataList,
  favoriteStoreList,
  { TYPE_TAKE_WAY, DINE_IN, dispositionType, callSelectedStore, callSelectedFavStore },
) => {
  if (firstTab) {
    eligibleStoreDataList.length &&
      [TYPE_TAKE_WAY, DINE_IN].indexOf(dispositionType.toUpperCase()) > -1 &&
      callSelectedStore();
  } else {
    favoriteStoreList.length &&
      [TYPE_TAKE_WAY, DINE_IN].indexOf(dispositionType.toUpperCase()) > -1 &&
      callSelectedFavStore();
  }
};

export const firstTabGetlat = (firstTab, getLatLongInfo, getLatLongInfoFavStore) => {
  if (firstTab === true) {
    return getLatLongInfo();
  } else {
    return getLatLongInfoFavStore();
  }
};

export const firstTabSelecedStore = (firstTab, setSelectedStore, eligibleStoreDataList, favoriteStoreList, index) => {
  if (firstTab === true) {
    return setSelectedStore(getValueOrDefaultObject(eligibleStoreDataList[index]));
  } else {
    return setSelectedStore(favoriteStoreList?.[index]);
  }
};

export const filterStoreMarkerFav = (
  favoriteStoreList,
  callSelectedFavStore,
  setCenterIndex,
  latLongObj,
  centerIndex,
) => {
  const filterStoreMarker = favoriteStoreList.findIndex(
    store => store.location.latitude === latLongObj.lat() && store.location.longitude === latLongObj.lng(),
  );
  if (filterStoreMarker > -1) {
    centerIndex === filterStoreMarker && callSelectedFavStore();
    setCenterIndex(filterStoreMarker);
  }
};

/**
 * Guest login Form
 * @param {*} props - Object
 */
const SearchStoreModuleForm = props => {
  const {
    formContent = {},
    storeData = [],
    eligibleStoreData = [],
    favoriteStoreData = [],
    userPositionHandler,
    singInClickhandler,
    currentMarket,
    storeCardLimit = Infinity,
    onStoreSelectFinish,
    handleGoBack,
    noStoresList,
    favoriteStoreHandler,
  } = props;
  const {
    memberText = '',
    singInLink = {},
    currentLocationText = '',
    addressBoxPlaceHolderForSearchStore = '',
    mapText = '',
  } = formContent;

  const {
    MIN_SEARCH_CHARACTER_LIMIT,
    SUUGESTED_ITEMS_TEXT,
    ALLOWED_SUGGESTION_LIST: allowedSuggestionList,
    ALREADY_SERACHED_LOCATIONS,
    COUNTRY_CODE: countryCode,
    SUGGESTION_ACTIVE_COLOR: suggestionHighLightColor,
    SUGGESTION_ACTIVE_OPACITY: suggestionOpacity,
    BRAND_BLACK: brandBlack,
    STORE_STATUS_OPEN,
    LIST_TEXT,
    TYPE_TAKE_WAY,
    STORE_STATUS_CLOSED_CAPS,
    BROWSE_MENU,
    CTA1_SEARCH_DIFF_ADDRESS,
    DINEIN_UNAVAILABLE,
    CTA2_ORDER_TAKEAWAY,
    TAKEAWAY_UNAVAILABLE_WITH_CTA,
    DINE_IN_SERVICE,
    DINE_IN,
    TYPE_DELIVERY,
    TAKE_AWAY,
  } = SEARCH_STORE_CONSTANTS;
  const { DISPOSITION_METHOD } = START_ORDER_CONSTANTS;
  const { MENU_URL, SEARCH_ORDER_DATA, CURRENT_STORE_INFO, DISPOSITION_DATA, INDIA } = START_ORDER_CONSTANTS;

  // get the context from parent
  const { userOrderState } = React.useContext(UserOrderContext);
  const { searchStoreData = {}, dispositionStateData = {}, scheduleOrderData = {} } = userOrderState;
  const { dispositionType = localStorage.getItem('dispositionType') } = dispositionStateData;
  // use searchStoreData.userAddress as initial value if you want to hold the address data while switching modals
  const [address, setAddress] = React.useState('');
  const [latLongValues, setLatLongValues] = useState({});
  const [currentLatLongValues, setCurrentLatLongValues] = useState({});
  const [showMap, setShowMap] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [eligibleStoreDataList, setEligibleStoreDataList] = React.useState([]);
  const [useMyLocationClick, setUseMyLocationClick] = React.useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  let totalStoreCount = 0;
  const [centerIndex, setCenterIndex] = useState(0);
  const [backupUseMyLocation, setBackupUseMyLocation] = useState('');
  const [noStoreStatus, setNoStoreStatus] = React.useState(false);
  const [closedStoreDataList, setClosedStoreDataList] = React.useState([]);
  const [closedEmergencyStoreDataList, setClosedEmergencyStoreDataList] = React.useState([]);
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  let totalClosedStoreCount = 0;
  let errorMsgToShow;
  const dispatch = useDispatch();
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { tenantId = {} } = tenantReducer || {};
  let totalFavoriteCount = 0;
  const [favStore, setFavStore] = React.useState(false);
  const appStateReducer = useSelector(data => data.appStateReducer);
  const { isLoading } = useSelector(data => getValueOrDefaultObject(data.LoaderReducer));
  const { userStatus = {} } = appStateReducer;
  const { loggedIn = false } = userStatus;
  const [favoriteStoreList, setFavoriteStoreList] = React.useState([]);
  const [firstTab, setfirstTab] = React.useState(true);
  const { customerId } = AuthManager.getInstance();

  const [storeCardHeight, setStoreCardHeight] = useState(325);
  const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  }, [isMobile]);
  useEffect(() => {
    window.addEventListener('keydown', keyDownUpArrows);
    return () => {
      window.removeEventListener('keydown', keyDownUpArrows);
    };
  });
  const mapStoreCardHeight = document.getElementById('map-store-card')?.clientHeight;
  useEffect(() => {
    if (mapStoreCardHeight && storeCardHeight !== mapStoreCardHeight) {
      setStoreCardHeight(mapStoreCardHeight);
    }
    // eslint-disable-next-line
  }, [mapStoreCardHeight]);

  /**
   *
   * @param {*} value representing user's selection
   */
  const handleSelectAddress = async value => {
    const results = await geocodeByAddress(value);
    const latLong = await getLatLng(results[0]);
    setLatLongValues(latLong);
    setCurrentLatLongValues(latLong);

    totalStoreCount = 0;
    setLocalStorage(value);
    setAddress(value);
    userPositionHandler({ userLat: latLong.lat, userLong: latLong.lng });
    setUseMyLocationClick(false);

    const conditionNoStoreStatus = Boolean(
      getAndCheck(
        getValueOrDefaultAlternativeObject(address, value),
        getAndCheck(totalStoreCount === 0, totalClosedStoreCount === 0),
      ),
    );
    setNoStoreStatus(conditionNoStoreStatus);
  };

  /** redirect to menu page function */
  const gotoMenuPage = () => {
    // update store info in localstorage
    localStorage.setItem('currentStoreInfo', JSON.stringify(null));
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: null,
    });
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    props.history.push({
      pathname: `${MENU_URL}`,
    });
  };

  const orderTakeawayHandler = e => {
    e.preventDefault();
    userOrderStateDispatch({ type: DISPOSITION_METHOD, value: { dispositionType: TAKE_AWAY } });
    handleSelectAddress(address);
  };
  const getErrorForFirstTabList = () => {
    return totalStoreCount === 0 &&
      totalClosedStoreCount === 0 &&
      noStoreStatus &&
      !noStoresList &&
      !eligibleStoreDataList.length
      ? noStoreView(showNoErrorText, gotoMenuPage, CTA1_SEARCH_DIFF_ADDRESS)
      : getView();
  };

  const noStoreView = (showNoErrorText, gotoMenuPage, CTA1_SEARCH_DIFF_ADDRESS) => {
    return (
      <div className='store-card'>
        {dispositionType.toUpperCase() === TYPE_TAKE_WAY ? (
          <div className='no-store'>
            <div className='no-store-icon'>
              <ImageComponent data-testid='' srcFile={ErrorImage} alt={'no store'} />
            </div>
            <div className='no-store-text'>{showNoErrorText()}</div>
            <ButtonComp
              data-testid='menupageBtn-id'
              className='button whiteButton blackBorder store-card-btn'
              onClickHandler={onClearTextHandler}
            >
              {translateWithI18Next(CTA1_SEARCH_DIFF_ADDRESS)}
            </ButtonComp>
          </div>
        ) : (
          <div className='no-store'>
            <div className='no-store-icon'>
              <ImageComponent data-testid='' srcFile={ErrorImage} alt={'no store'} />
            </div>
            <div className='no-store-text'>{showNoErrorText()}</div>
            <ButtonComp
              data-testid='menupageBtn-id'
              className='button whiteButton blackBorder store-card-btn dine-in-error-btn'
              onClickHandler={onClearTextHandler}
            >
              {translateWithI18Next(CTA1_SEARCH_DIFF_ADDRESS)}
            </ButtonComp>
            <ButtonComp
              data-testid='orderTakeaway-click-btn'
              className='button whiteButton blackBorder location-warning-button ml dine-in-error-btn'
              onClick={e => orderTakeawayHandler(e)}
            >
              {translateWithI18Next(CTA2_ORDER_TAKEAWAY)}
            </ButtonComp>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (!scheduleOrderData?.changeFlow && searchStoreData?.searchedPlaceNonLocalized) {
      handleSelectAddress(searchStoreData.searchedPlaceNonLocalized);
    } else if (localStorage.getItem('searchStoreByAttribute')) {
      let searchAttr = localStorage.getItem('searchStoreByAttribute');
      setAddress(searchAttr);
      handleSelectAddress(searchAttr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inputOnChange = val => {
    if (!val) {
      onClearTextHandler();
    }
    setAddress(val);

    if (getLength(val) < 3) {
      setShowAutoSuggestion(false);
    }
  };
  const passAddress = addr => {
    setAddress(addr);
  };

  useEffect(() => {
    if (address) {
      let finalEligibleStoreData = eligibleStoreData.filter(getStoresWithCatalog);
      if (finalEligibleStoreData.length > 0) {
        let finalEligibleStoreOpenData = finalEligibleStoreData.filter(
          storeInfo =>
            storeInfo.summary?.status?.currentStatus === STORE_STATUS_OPEN &&
            storeInfo.summary?.timings?.scheduled?.periods?.length > 0,
        );
        if (finalEligibleStoreOpenData.length >= storeCardLimit) {
          let ActualOpenStores = finalEligibleStoreOpenData.slice(0, storeCardLimit);
          setEligibleStoreDataList(ActualOpenStores);
        } else if (finalEligibleStoreOpenData.length < storeCardLimit) {
          let ActualLength = storeCardLimit - finalEligibleStoreOpenData.length;
          let finalEligibleStoreClosedData = finalEligibleStoreData.filter(
            storeInfo =>
              storeInfo.summary?.status?.currentStatus === STORE_STATUS_CLOSED_CAPS ||
              storeInfo.summary?.timings?.scheduled?.periods?.length === 0,
          );
          let RequiedClosedStore = finalEligibleStoreClosedData.slice(0, ActualLength);
          let FinalArray = finalEligibleStoreOpenData.concat(RequiedClosedStore);
          setEligibleStoreDataList(FinalArray);
        }
      } else {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        totalStoreCount = 0;
        setEligibleStoreDataList([]);
      }
    } else {
      setEligibleStoreDataList([]);
      setFavoriteStoreList([]);
      setClosedStoreDataList([]);
      setNoStoreStatus(false);
    }
  }, [eligibleStoreData, address]);

  useEffect(() => {
    if (eligibleStoreData.length > 0) {
      favoriteStoreHandler({
        userLat: currentLatLongValues.lat,
        userLong: currentLatLongValues.lng,
      });
      const sortedStoreInfo = favoriteStoreData.sort((storeOne, storeTwo) => compareDname(storeOne, storeTwo));
      const eligibleStores = sortedStoreInfo?.filter(store => store?.summary?.status?.currentStatus);
      setFavoriteStoreList(eligibleStores);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibleStoreData, favoriteStoreData.length]);

  useEffect(() => {
    /**
     * populate input text box when user select use my location
     */
    if (useMyLocationClick) {
      setAddress(backupUseMyLocation);
      setLocalStorage(backupUseMyLocation);
      setUseMyLocationClick(false);
    }

    if (localStorage.getItem('ALREADY_SERACHED_LOCATIONS') !== address) {
      setEligibleStoreDataList([]);
      setClosedStoreDataList([]);
      setSelectedStore('');
      setFavoriteStoreList([]);
    }
    let autoSuggestionCondition = addressSuggestionLengthMatch(address, MIN_SEARCH_CHARACTER_LIMIT);
    setShowAutoSuggestion(autoSuggestionCondition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStoreData, address, useMyLocationClick, backupUseMyLocation]);

  /**
   * Mehtod to store search value to locastorage
   * @param {*} value representing user's selection
   */
  const setLocalStorage = value => {
    manipulateAlreadySearchedLocations(value, ALREADY_SERACHED_LOCATIONS);
  };
  /**
   * Mehtod to search value from locastorage
   * @param {*} description representing seggestion's description
   */
  const getLocalStorage = description => {
    const allSeachedLocations = getValueOrDefaultArray(JSON.parse(localStorage.getItem(ALREADY_SERACHED_LOCATIONS)));
    return allSeachedLocations.includes(description);
  };

  /**
   * method to get the lat and long data when user choose's current location
   */
  const useCurrentLocation = async () => {
    localisationStartAnalytics();
    await ChannelManager.BindLocation();
    setUseMyLocationAnalytics();
    if (ChannelManager.coordinates) {
      const { latitude: userLat, longitude: userLong } = ChannelManager.coordinates;

      ChannelManager.addFeedback(`Check coordinates ${JSON.stringify(ChannelManager.coordinates)}`);
      ChannelManager.addFeedback(`Check assignment ${JSON.stringify({ userLat, userLong })}`);
      ChannelManager.addFeedback(`Check address ${ChannelManager.address}`);
      totalStoreCount = 0;
      setLatLongValues({ lat: userLat, lng: userLong });
      setShowMap(false);
      userPositionHandler({ userLat, userLong });
      setNoStoreStatus(true);
      setAddress(ChannelManager.address);
      setBackupUseMyLocation(ChannelManager.address);
      setUseMyLocationClick(true);
    }
  };

  /**
   *
   * @param {*} value - Method to check if the user has already serached for this location earlier or not
   */
  const alreadySearched = value => {
    return getLocalStorage(value);
  };

  const onClearTextHandler = () => {
    setAddress('');
    setFavoriteStoreList([]);
    setEligibleStoreDataList([]);
    setClosedStoreDataList([]);
    setNoStoreStatus(false);
    setSelectedStore('');
    setShowMap(false);
  };
  const getLatLongInfo = useCallback(async () => {
    const latLongValue = await Promise.all(
      eligibleStoreDataList.map(async store => {
        return { lat: store.location.latitude, lng: store.location.longitude };
      }),
    );
    setLatLongValues(latLongValue);
  }, [eligibleStoreDataList]);

  const getLatLongInfoFavStore = useCallback(async () => {
    const latLongValue = await Promise.all(
      favoriteStoreList.map(async store => {
        return { lat: store.location.latitude, lng: store.location.longitude };
      }),
    );
    setLatLongValues(latLongValue);
  }, [favoriteStoreList]);

  const toggleMapView = () => {
    localisationViewAnalyticsData(showMap, dispositionType);
    setShowMap(!showMap);
    setShowCard(!showMap);
  };

  const setStoreInfo = (item, index) => {
    setSelectedStore(item);
    setCenterIndex(index);
  };
  const callSelectedStore = () => {
    getLatLongInfo();
    setShowCard(true);
    setSelectedStore(getValueOrDefaultObject(eligibleStoreDataList[centerIndex]));
  };
  const callSelectedFavStore = async () => {
    await getLatLongInfoFavStore();
    setShowCard(true);
    setSelectedStore(getValueOrDefaultObject(favoriteStoreList[centerIndex]));
  };
  useEffect(() => {
    eligibleStoreFun(firstTab, eligibleStoreDataList, favoriteStoreList, {
      TYPE_TAKE_WAY,
      DINE_IN,
      dispositionType,
      callSelectedStore,
      callSelectedFavStore,
    });
    let closedStoreList = eligibleStoreDataList.filter(
      store =>
        store.summary?.status?.currentStatus === STORE_STATUS_CLOSED_CAPS ||
        store.summary?.timings?.scheduled?.periods?.length === 0,
    );

    let closedEmergencyStoreList = eligibleStoreDataList.filter(store => {
      const isClosed = store.summary.status.currentStatus === 'CLOSED';
      const isEmergencyShutdown = store?.summary?.status?.message?.indexOf('EMERGENCY_SHUTDOWN') !== -1;
      const isTechnicalShutdown = store?.summary?.status?.message?.indexOf('TECHNICAL_SHUTDOWN') !== -1;
      const { futureDates, scheduled: initiallyScheduled, asap } = store?.summary?.timings;
      const { unavailibilities } = initiallyScheduled;
      const { interval: initialInterval = 0, startEndTime = {} } =
        initiallyScheduled && initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0];
      const { from, to } = startEndTime;
      const arr = getList(
        from,
        to,
        initialInterval,
        asap?.isAvailable,
        futureDates.length === 1 && tenantReducer?.country?.toUpperCase() === INDIA,
        unavailibilities,
      );
      return (!arr || arr.length === 0) && isClosed && (isEmergencyShutdown || isTechnicalShutdown);
    });
    setClosedStoreDataList(closedStoreList);
    setClosedEmergencyStoreDataList(closedEmergencyStoreList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    eligibleStoreDataList,
    centerIndex,
    selectedStore,
    noStoresList,
    DINE_IN,
    STORE_STATUS_CLOSED_CAPS,
    TYPE_TAKE_WAY,
    dispositionType,
    getLatLongInfo,
    firstTab,
    favoriteStoreList,
  ]);

  const onPositionChangeHandler = pointer => {
    setSelectedStore('');
    let index = pointer ? centerIndex + 1 : centerIndex - 1;
    setCenterIndex(index);
    firstTabSelecedStore(firstTab, setSelectedStore, eligibleStoreDataList, favoriteStoreList, index);
  };

  const handleTabChange = value => {
    setfirstTab(value);
  };

  const setLocalFav = () => {
    localStorage.setItem('setFav', true);
    localStorage.removeItem('renderComp');
  };

  const addToFavoriteHandler = selectedStoreInfo => {
    setLocalFav();
    dispatch(
      setStoresFavourite({
        data: {
          storeId: selectedStoreInfo.id,
        },
        tenantId: tenantId,
        customerId: customerId,
        dispatch: 'dispatch',
      }),
    );
    setFavStore(true);
  };

  const removeFromFavoriteHandler = selectedStoreInfo => {
    setLocalFav();
    dispatch(
      setStoresUnFavourite({
        tenantId: tenantId,
        customerId: customerId,
        storeId: getValueOrDefaultObject(selectedStoreInfo.id),
        dispatch: 'dispatch',
      }),
    );
    setFavStore(false);
  };

  useEffect(() => {
    if (favStore) {
      toast.dark(
        <div className='img-text-div'>
          <ImageComponent data-testid='' srcFile={SuccessImg} alt={'success'} className='success-img' />
          Saved to your favorite store
        </div>,
        {
          className: 'favorites',
          bodyClassName: 'toast-for-favorite',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteStoreData.length]);

  useEffect(() => {
    if (totalStoreCount === 0 && totalClosedStoreCount === 0 && noStoreStatus && !noStoresList && !isLoading) {
      if (dispositionType.toUpperCase() === TYPE_TAKE_WAY) {
        getEmbeddedErrorMessageAnalytic(
          translateWithI18Next(SEARCHSTORE_MODULE_DATA.contentData.searchStoreHeaderText),
          translateWithI18Next(TAKEAWAY_UNAVAILABLE_WITH_CTA),
        );
      } else {
        getEmbeddedErrorMessageAnalytic(
          translateWithI18Next(SEARCHSTORE_MODULE_DATA.contentData.searchStoreHeaderText),
          translateWithI18Next(DINEIN_UNAVAILABLE),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalStoreCount, totalClosedStoreCount, noStoreStatus, noStoresList, isLoading]);

  const storeCard = (item, index) => {
    const isOpen = item?.summary?.status?.currentStatus === STORE_STATUS_OPEN;
    const webChannel = item.availableServicesPerChannel && getChannels(item.availableServicesPerChannel);
    const { services: orderTypes = [] } = webChannel[0];
    const closedStoreKey = `${item.name[0].value}_${index}`;
    return (
      <React.Fragment>
        {isOpen ? (
          <SearchStoreCard
            key={index}
            data-testid={index}
            storeName={getValueOrEmptyString(item.name[0].value)}
            storeDistance={getValueOrDefaultAlternativeObject(item?.distance?.value, item?.distance)}
            channels={item.availableServicesPerChannel}
            storeStatus={item.summary}
            addresses={getValueOrDefaultObject(item.addresses[0].address)}
            {...storeData[0]}
            storeInfo={item}
            currentMarket={currentMarket}
            isOpen={isOpen}
            isMapView={true}
            onStoreSelectFinish={onStoreSelectFinish}
            isMobile={isMobile}
            centerIndex={centerIndex}
            storeLength={getTernaryValue(firstTab, eligibleStoreDataList?.length, favoriteStoreList?.length)}
          />
        ) : (
          <SearchStoreClosedCard
            key={closedStoreKey}
            orderTypes={orderTypes}
            storeName={getValueOrEmptyString(item.name[0].value)}
            storeDistance={getValueOrDefaultAlternativeObject(item?.distance?.value, item?.distance)}
            addresses={getValueOrDefaultObject(item.addresses[0].address)}
            storeStatus={item.summary}
            onStoreSelectFinish={onStoreSelectFinish}
            isMobile={isMobile}
            isMapView={true}
            storeInfo={item}
            mapText={mapText}
            onClick={() => {
              toggleMapView();
              getLatLongInfo();
            }}
            {...storeData[0]}
            onPositionChangeHandler={onPositionChangeHandler}
            centerIndex={centerIndex}
            storeLength={getTernaryValue(firstTab, eligibleStoreDataList?.length, favoriteStoreList?.length)}
          />
        )}
      </React.Fragment>
    );
  };

  const favoriteCard = favoriteStoreList.forEach((item, index) => {
    if (item.summary?.status?.currentStatus === STORE_STATUS_OPEN) {
      const isOpen = item.summary?.status?.currentStatus === STORE_STATUS_OPEN;
      isOpen && totalFavoriteCount++;
      return (
        <React.Fragment>
          <SearchStoreCard
            key={index}
            data-testid={index}
            storeName={getValueOrEmptyString(item.name[0].value)}
            storeDistance={getValueOrEmptyString(item.distance.value)}
            channels={item.availableServicesPerChannel}
            storeStatus={item.summary}
            addresses={getValueOrDefaultObject(item.addresses[0].address)}
            {...storeData[0]}
            storeInfo={item}
            currentMarket={currentMarket}
            isOpen={isOpen}
            onStoreSelectFinish={onStoreSelectFinish}
            isMobile={isMobile}
            loggedIn={loggedIn}
            onClickMapHandler={() => {
              setStoreInfo(item, index);
              toggleMapView();
            }}
            isFavoriteStore={true}
            addToFavoriteHandler={() => {
              addToFavoriteHandler(item);
            }}
            removeFromFavoriteHandler={() => {
              removeFromFavoriteHandler(item);
            }}
          />
        </React.Fragment>
      );
    } else if (item.summary?.status?.currentStatus === STORE_STATUS_CLOSED_CAPS) {
      totalFavoriteCount++;
      const webChannel = item.availableServicesPerChannel && getChannels(item.availableServicesPerChannel);
      const { services: orderTypes = [] } = webChannel[0];
      const closedStoreKey = `${item.name[0].value}_${index}`;
      return (
        <React.Fragment>
          <SearchStoreClosedCard
            key={closedStoreKey}
            storeName={getValueOrEmptyString(item.name[0].value)}
            storeDistance={getValueOrEmptyString(item.distance.value)}
            orderTypes={orderTypes}
            addresses={getValueOrDefaultObject(item.addresses[0].address)}
            storeStatus={item.summary}
            mapText={mapText}
            isMobile={isMobile}
            loggedIn={loggedIn}
            onClickMapHandler={() => {
              setStoreInfo(item, index);
              toggleMapView();
            }}
            isFavoriteStore={true}
            addToFavoriteHandler={() => {
              addToFavoriteHandler(item);
            }}
            removeFromFavoriteHandler={() => {
              removeFromFavoriteHandler(item);
            }}
            onStoreSelectFinish={onStoreSelectFinish}
            storeInfo={item}
            {...storeData[0]}
          />
        </React.Fragment>
      );
    }
  });

  const setStoreMarker = latLongObj => {
    const filterStoreMarker = eligibleStoreDataList.findIndex(
      store => store.location.latitude === latLongObj.lat() && store.location.longitude === latLongObj.lng(),
    );
    if (filterStoreMarker > -1) {
      centerIndex === filterStoreMarker && callSelectedStore();
      setCenterIndex(filterStoreMarker);
    }
  };

  const setStoreMarkerFavStore = latLongObj => {
    filterStoreMarkerFav(favoriteStoreList, callSelectedFavStore, setCenterIndex, latLongObj, centerIndex);
  };
  /**
   * Cards for the stores
   */

  const orderCard = eligibleStoreDataList.map((item, index) => {
    if (!address) {
      setEligibleStoreDataList([]);
    }
    if (totalStoreCount >= storeCardLimit || item.summary?.timings?.scheduled?.periods?.length === 0) {
      return null;
    } else {
      const isOpen = item.summary?.status?.currentStatus === STORE_STATUS_OPEN;
      isOpen && totalStoreCount++;
      return (
        <React.Fragment>
          <SearchStoreCard
            key={index}
            data-testid={index}
            storeName={getValueOrEmptyString(item.name[0].value)}
            storeDistance={getValueOrEmptyString(item.distance)}
            channels={item.availableServicesPerChannel}
            storeStatus={item.summary}
            addresses={getValueOrDefaultObject(item.addresses[0].address)}
            {...storeData[0]}
            storeInfo={item}
            currentMarket={currentMarket}
            isOpen={isOpen}
            onStoreSelectFinish={onStoreSelectFinish}
            isMobile={isMobile}
            loggedIn={loggedIn}
            onClickMapHandler={() => {
              setStoreInfo(item, index);
              toggleMapView();
            }}
            isFavoriteStore={favoriteStoreData.some(store => store.id === item.id)}
            addToFavoriteHandler={() => {
              addToFavoriteHandler(item);
            }}
            removeFromFavoriteHandler={() => {
              removeFromFavoriteHandler(item);
            }}
          />
        </React.Fragment>
      );
    }
  });

  /*eslint no-irregular-whitespace: ["error", { "skipComments": true }]*/

  const getNegativeView = () => {
    let serviceType = dispositionType.toLowerCase().indexOf('dine') !== -1 ? DINE_IN_SERVICE : dispositionType;
    errorMsgToShow = callUtilFunct(serviceType, eligibleStoreData);
    if (errorMsgToShow) {
      return (
        <React.Fragment>
          <NegativeScenarioErros
            errorMsgToShow={errorMsgToShow}
            onClearTextHandler={onClearTextHandler}
            dispositionType={dispositionType}
            handleGoBack={handleGoBack}
          />
        </React.Fragment>
      );
    }
  };

  const getView = () => {
    if (
      eligibleStoreDataList.length === closedEmergencyStoreDataList.length &&
      closedEmergencyStoreDataList.length > 0
    ) {
      let serviceType = dispositionType.toLowerCase().indexOf('dine') !== -1 ? DINE_IN_SERVICE : dispositionType;
      let errorMessage = callUtilFunct(serviceType, eligibleStoreData);
      getEmbeddedErrorMessageAnalytic(
        translateWithI18Next(SEARCHSTORE_MODULE_DATA.contentData.searchStoreHeaderText),
        translateWithI18Next(errorMessage),
      );
      return getNegativeView();
    } else if (eligibleStoreDataList.length === closedStoreDataList.length && closedStoreDataList.length) {
      return closedStoreCard;
    } else {
      let serviceType = dispositionType.toLowerCase().indexOf('dine') !== -1 ? DINE_IN_SERVICE : dispositionType;
      if (eligibleStoreDataList.length) {
        errorMsgToShow = callUtilFunct(serviceType, eligibleStoreDataList);
        if (errorMsgToShow) {
          return getNegativeView();
        }
      }
      if (totalStoreCount < 5) {
        orderCard.push(closedStoreCard);
      }

      return orderCard;
    }
  };

  const onSearchError = (status, clearSuggestions) => {
    clearSuggestions();
  };
  /**
   * cards for the closed store
   */
  const closedStoreCard = closedStoreDataList.map((store, index) => {
    const webChannel = store.availableServicesPerChannel && getChannels(store.availableServicesPerChannel);
    const { services: orderTypes = [] } = getValueOrDefaultArray(webChannel[0]);
    if (!address) {
      setEligibleStoreDataList([]);
    }
    if (totalClosedStoreCount >= storeCardLimit - totalStoreCount) {
      return null;
    } else {
      totalClosedStoreCount++;
      const closedStoreKey = `${store.name[0].value}_${index}`;
      const currentStoreInd = eligibleStoreDataList.findIndex(el => el.id === store.id);
      return (
        <React.Fragment>
          <SearchStoreClosedCard
            key={closedStoreKey}
            storeName={getValueOrEmptyString(store.name[0].value)}
            storeDistance={getValueOrEmptyString(store.distance)}
            orderTypes={orderTypes}
            addresses={getValueOrDefaultObject(store.addresses[0].address)}
            storeStatus={store.summary}
            mapText={mapText}
            isMobile={isMobile}
            loggedIn={loggedIn}
            onClickMapHandler={() => {
              setStoreInfo(store, currentStoreInd);
              toggleMapView();
            }}
            isFavoriteStore={favoriteStoreData.some(fav => fav.id === store.id)}
            addToFavoriteHandler={() => {
              addToFavoriteHandler(store);
            }}
            removeFromFavoriteHandler={() => {
              removeFromFavoriteHandler(store);
            }}
            onStoreSelectFinish={onStoreSelectFinish}
            storeInfo={store}
            {...storeData[0]}
          />
        </React.Fragment>
      );
    }
  });
  /**
   * Map view of the closed stores
   */
  const mapClosedStoreCard = (item, index) => {
    const webChannel = item.availableServicesPerChannel && getChannels(item.availableServicesPerChannel);
    const { services: orderTypes = [] } = getValueOrDefaultArray(webChannel[0]);
    const closedStoreKey = `${item.name[0].value}_${index}`;
    return (
      <React.Fragment>
        <SearchStoreClosedCard
          key={closedStoreKey}
          storeName={getValueOrEmptyString(item.name[0].value)}
          storeDistance={getValueOrEmptyString(item.distance)}
          orderTypes={orderTypes}
          addresses={getValueOrDefaultObject(item.addresses[0].address)}
          storeStatus={item.summary}
          mapText={mapText}
          isMobile={isMobile}
          isMapView={true}
          onStoreSelectFinish={onStoreSelectFinish}
          onClick={() => {
            toggleMapView();
            getLatLongInfo();
          }}
          storeInfo={item}
          {...storeData[0]}
          centerIndex={centerIndex}
          storeLength={getTernaryValue(firstTab, eligibleStoreDataList?.length, favoriteStoreList?.length)}
        />
      </React.Fragment>
    );
  };

  const showNoErrorText = () => {
    switch (dispositionType.split('-').join(' ').toUpperCase()) {
      case TYPE_TAKE_WAY:
        return translateWithI18Next(TAKEAWAY_UNAVAILABLE_WITH_CTA); //(NO_STORE_ERROR_TEXT_TAKEAWAY);
      case DINE_IN:
        return translateWithI18Next(DINEIN_UNAVAILABLE); //(NO_STORE_ERROR_TEXT_DINEIN);
      default:
        return null;
    }
  };

  const handleTotalStoreCount = () => {
    setCenterIndex(0);
    toggleMapView();
    firstTabGetlat(firstTab, getLatLongInfo, getLatLongInfoFavStore);
  };

  return (
    <React.Fragment>
      <div className='searchStore-module-form' data-testid='searchstore-component'>
        <div>
          <div className='store-count'>
            <span className='member-signin'>
              {!loggedIn && (
                <div data-id={Config.HEADER_SIGN_IN_ATTR_DATA_ID} data-testid='memberText'>
                  {translateWithI18Next(memberText)}
                  <span onClick={singInClickhandler}>
                    <AnchorWithLink
                      className='store-signin-link'
                      targettype={singInLink.targetType}
                      href={singInLink.linkUrl}
                      data-testid='store-signin-link'
                    >
                      {translateWithI18Next(singInLink.linkText)}
                    </AnchorWithLink>
                  </span>
                </div>
              )}
            </span>
            <span>
              <AnchorWithLink
                onClickHandler={useCurrentLocation}
                className='store-location-link'
                data-testid='useCurrentLocation'
              >
                <ImageComponent data-testid='' srcFile={LocationImage} alt={'location'} className='location-img' />
                {translateWithI18Next(currentLocationText)}
              </AnchorWithLink>
            </span>
          </div>
          <div className='search-address'>
            <div className='input-address'>
              <PlacesAutocomplete
                data-testid='handle-select'
                value={address}
                onChange={inputOnChange}
                onSelect={handleSelectAddress}
                searchOptions={{ componentRestrictions: { country: countryCode } }}
                shouldFetchSuggestions={true}
                onError={onSearchError}
              >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
                  return (
                    <div>
                      <div
                        className={`${
                          errorMsgToShow ||
                          (totalStoreCount === 0 &&
                            totalClosedStoreCount === 0 &&
                            noStoreStatus &&
                            noStoresList &&
                            !eligibleStoreDataList.length)
                            ? 'search-container-data error-border'
                            : 'search-container-data'
                        }`}
                      >
                        <ImageComponent
                          data-testid=''
                          srcFile={GoogleMapLocationImage}
                          alt={'googleMapLocation'}
                          className='google-location-img'
                        />
                        <input
                          data-testid='store-search-input'
                          className='store-search-input t-2'
                          {...getInputProps({
                            placeholder: translateWithI18Next(addressBoxPlaceHolderForSearchStore),
                          })}
                        />
                        {address && (
                          <img
                            data-testid='clear-text-icon'
                            src={clearTextIcon}
                            className='clearTextIcon'
                            onClick={() => onClearTextHandler()}
                            alt='Clear Text Icon'
                          />
                        )}
                      </div>
                      {!!getAndCheck(getLength(suggestions), showAutoSuggestion) && (
                        <div className='suggestion-list' data-testid='suggestionlist-id'>
                          {suggestions.map((suggestion, index) => {
                            if (suggestion?.types?.some(itemType => allowedSuggestionList.includes(itemType))) {
                              const style = suggestion.active
                                ? {
                                    backgroundColor: suggestionHighLightColor,
                                    opacity: suggestionOpacity,
                                  }
                                : { backgroundColor: brandBlack };
                              return (
                                <React.Fragment>
                                  {index === 0 && (
                                    <div
                                      className='suggestion-items suggest-text'
                                      id='suggestion-text'
                                      data-testid={`suggestion-item-${index}`}
                                    >
                                      {translateWithI18Next(SUUGESTED_ITEMS_TEXT)}
                                    </div>
                                  )}
                                  <div style={style}>
                                    <div
                                      key={index}
                                      data-testid={`suggestion-item-${index}`}
                                      {...getSuggestionItemProps(suggestion, {
                                        className: 'suggestion-items',
                                        id: 'suggestion-items',
                                      })}
                                    >
                                      <div className='suggested-address-alignment'>
                                        <div>
                                          <ImageComponent
                                            data-testid=''
                                            srcFile={
                                              alreadySearched(suggestion.description)
                                                ? Time_Clock
                                                : SuggestionItemSearchPin
                                            }
                                            alt={'googleMapLocation'}
                                            className='suggetion-pin'
                                            id='suggetion-pin'
                                          />
                                        </div>
                                        <div className='suggestion-description'>{suggestion.description}</div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            }
                          })}
                        </div>
                      )}
                    </div>
                  );
                }}
              </PlacesAutocomplete>
            </div>
          </div>
        </div>
        <div className='my-3 store-form-separation margin-bottom' />
        {getMapAndListLink(address, showMap, LIST_TEXT, toggleMapView, getLatLongInfo)}
        <form className='form'>
          <div className='store-count'>
            {!!totalStoreCount && (
              <span
                data-testid='tab-open-store'
                className={getEligibleStoreHeader(loggedIn, firstTab)}
                onClick={() => {
                  setCenterIndex(0);
                  handleTabChange(true);
                }}
              >
                {!loggedIn ? (
                  <span>
                    {totalStoreCount + totalClosedStoreCount} {`${translateWithI18Next('nearYou')}`}
                  </span>
                ) : (
                  <span>
                    {' '}
                    {`${translateWithI18Next('nearYou')}`} ({totalStoreCount + totalClosedStoreCount})
                  </span>
                )}
              </span>
            )}
            {!!totalClosedStoreCount &&
              eligibleStoreDataList.length === closedStoreDataList.length &&
              eligibleStoreDataList.length !== closedEmergencyStoreDataList.length && (
                <span
                  data-testid='tab-closed-store'
                  className={getEligibleStoreHeader(loggedIn, firstTab)}
                  onClick={() => {
                    setCenterIndex(0);
                    handleTabChange(true);
                  }}
                >{`${translateWithI18Next('nearYou')} (${totalClosedStoreCount})`}</span>
              )}
            {totalStoreCount === 0 && totalClosedStoreCount === 0 && noStoreStatus && noStoresList && (
              <span className='store-count-title'>{`${translateWithI18Next('nearYou')} (${totalStoreCount})`}</span>
            )}
            {getTotalStoreCount(totalStoreCount, totalClosedStoreCount, loggedIn, totalFavoriteCount, {
              firstTab,
              setCenterIndex,
              handleTabChange,
            })}
            {(!!totalStoreCount || !!totalClosedStoreCount) &&
              eligibleStoreDataList.length !== closedEmergencyStoreDataList.length && (
                <div
                  data-testid='togglemap-id'
                  onClick={() => {
                    handleTotalStoreCount();
                  }}
                >
                  <AnchorWithLink className='map-link'>
                    <span>
                      <ImageComponent data-testid='' srcFile={getSourceFile(showMap)} alt={'map'} className='map-img' />
                    </span>
                    {showMap ? translateWithI18Next(LIST_TEXT) : mapText}
                  </AnchorWithLink>
                </div>
              )}
            {totalStoreCount === 0 && totalClosedStoreCount === 0 && noStoreStatus && noStoresList && (
              <div
                data-testid='show-map-div'
                onClick={() => {
                  handleTotalStoreCount();
                }}
              >
                <AnchorWithLink className='map-link'>
                  <span>
                    <ImageComponent data-testid='' srcFile={getSourceFile(showMap)} alt={'map'} className='map-img' />
                  </span>
                  {showMap ? translateWithI18Next(LIST_TEXT) : translateWithI18Next(mapText)}
                </AnchorWithLink>
              </div>
            )}
          </div>
          {!showMap ? (
            <>
              {getAndCheck(!isLoading, getAndCheck(firstTab, getErrorForFirstTabList()))}
              {loggedIn && !firstTab && <div className='order-button-section'>{favoriteCard}</div>}
            </>
          ) : (
            <div className='order-button-section'>
              {totalStoreCount === 0 && totalClosedStoreCount === 0 && noStoreStatus && noStoresList && (
                <div className='store-card store-card-map-view-error'>
                  <div className='no-store'>
                    <div className='no-store-icon'>
                      <ImageComponent data-testid='' srcFile={ErrorImage} alt={'no store'} />
                    </div>
                    <div className='no-store-text'>{showNoErrorText()}</div>
                    <ButtonComp
                      className='button whiteButton blackBorder store-card-btn browse-menu-btn'
                      onClickHandler={gotoMenuPage}
                    >
                      {translateWithI18Next(BROWSE_MENU)}
                    </ButtonComp>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className='clearfix'></div>
        </form>
      </div>
      {showMap && (
        <>
          <div className={`${dispositionType?.toUpperCase() !== TYPE_DELIVERY && 'takeawayDineInMap'} delivery-map`}>
            <>
              <MyMapComponent
                latLongValue={latLongValues}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                passAddress={passAddress}
                isVisible={dispositionType.toUpperCase() === TYPE_TAKE_WAY || dispositionType.toUpperCase() === DINE_IN}
                isMobile={isMobile}
                centerIndex={centerIndex}
                onPositionChangeHandler={onPositionChangeHandler}
                setShowCard={setShowCard}
                setStoreMarker={getTernaryValue(firstTab, setStoreMarker, setStoreMarkerFavStore)}
                storeCardHeight={storeCardHeight}
              />
              {showCard && selectedStore && isMobile
                ? !errorMsgToShow && storeCard(selectedStore, 'Selected-Card')
                : null}
            </>
            {showCard && selectedStore && !isMobile
              ? (getAndCheck(eligibleStoreDataList.length === closedStoreDataList.length, firstTab) &&
                  !errorMsgToShow &&
                  mapClosedStoreCard(selectedStore, 'Selected-Card')) ||
                storeCard(selectedStore, 'Selected-Card')
              : ''}
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default withRouter(SearchStoreModuleForm);

function getMapAndListLink(address, showMap, LIST_TEXT, toggleMapView, getLatLongInfo) {
  return (
    <>
      {address?.length <= 3 && (
        <div className='enter-your-address-section'>
          <span className='search-store-text'>{translateWithI18Next('pleaseEnterLocation')}</span>
          <div
            data-testid='show-list-map'
            className={getTernaryValue(showMap, 'store-count', 'show-map-div')}
            onClick={() => {
              showMap && toggleMapView();
              getLatLongInfo();
            }}
          >
            <AnchorWithLink className='map-link'>
              <span>
                <ImageComponent data-testid='' srcFile={getSourceFile(showMap)} alt={'map'} className='map-img' />
              </span>
              {getTernaryValue(showMap, translateWithI18Next(LIST_TEXT), translateWithI18Next('map'))}
            </AnchorWithLink>
          </div>
        </div>
      )}
    </>
  );
}

function getTotalStoreCount(
  totalStoreCount,
  totalClosedStoreCount,
  loggedIn,
  totalFavoriteCount,
  { firstTab, setCenterIndex, handleTabChange },
) {
  return (
    <>
      {(!!totalStoreCount || !!totalClosedStoreCount) && loggedIn && (
        <span
          data-testid='tab-favorite-store'
          className={getTabStyle(firstTab)}
          onClick={() => {
            setCenterIndex(0);
            handleTabChange(false);
          }}
        >{`${translateWithI18Next('savedkfc')} (${totalFavoriteCount})`}</span>
      )}
    </>
  );
}
